import * as React from 'react';
import { FC } from 'react';

import { ResponsiveCarousel } from 'components/responsive-carousel';

import { RewardsCarouselCard } from './rewards-carousel-card';
import { RewardsCarouselContainer } from './rewards-carousel.styled';
import { IRewardsCarouselProps } from './types';

/**
 * A carousel for loyalty rewards
 */
export const RewardsCarousel: FC<IRewardsCarouselProps> = ({
  'data-testid': testId,
  rewards,
  className,
  children = [],
}) => {
  return (
    <RewardsCarouselContainer className={className} data-testid={testId}>
      <ResponsiveCarousel hideScrollBar bgColor="transparent">
        {rewards
          ? rewards
              .filter(reward => reward.isAvailable)
              .map(reward => <RewardsCarouselCard reward={reward} key={reward._id} />)
          : children}
      </ResponsiveCarousel>
    </RewardsCarouselContainer>
  );
};
